const Layout1Settings = {
    leftSidebar: {
      show: true,
      mode: 'full', // full, close, compact, mobile,
      theme: 'whitBlack', // View all valid theme colors inside MatxTheme/themeColors.js
      bgImgURL: '/assets/sidebar/sidebar-bg-dark.jpg',
    },
    topbar: {
      show: true,
      fixed: true,
      theme: 'greenWhite', // View all valid theme colors inside MatxTheme/themeColors.js
    },
  };
  
  export default Layout1Settings;